
import Additional from "@core/Additional.js";
import Constant from "@constant/index.js";
import Sku from "@core/Sku.js";

export default class GIFTAdditional extends Additional{
    constructor(){
        super();
        this._additionalType = Constant.ADDITIONAL_TYPE.GIFT;
    }

    init(data){
        this._data = data;
        this._data.forEach(x => {
            let _sku = new Sku();
            _sku.init(x, this);
            this.addItem(_sku);
        });
    }
}